import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AccessoryEditorMode, AccessoryEditorState } from '../accessory.component';

export interface AccessoryEditorAction {
  action: string;
  searchType?: string;
}

export interface AcessorySelectionUpdateAction {
  update: boolean;
  reset: boolean;
}

@Injectable({ providedIn: 'root' })
export class AccessoryEditorStateManager {
  private _editorState: AccessoryEditorState = AccessoryEditorState.CLOSED;
  private _editorMode: AccessoryEditorMode = AccessoryEditorMode.ACCESSORY;

  public readonly ACTION_CLOSE_ACCESSORIES = 'close';
  public readonly ACTION_OPEN_ACCESSORIES = 'open';
  public readonly ACTION_UPDATE_ACCESSORIES = 'update';

  private updateAccessorySelectionSubject: Subject<AcessorySelectionUpdateAction> = new Subject<AcessorySelectionUpdateAction>();
  public get updateAccessorySelection$(): Observable<AcessorySelectionUpdateAction> {
    return this.updateAccessorySelectionSubject.asObservable();
  }

  private actionAccessoriesEditorSubject: Subject<AccessoryEditorAction> = new Subject<AccessoryEditorAction>();
  public get actionAccessoriesEditor$(): Observable<AccessoryEditorAction> {
    return this.actionAccessoriesEditorSubject.asObservable();
  }

  get editorMode() {
    return this._editorMode;
  }

  get editorState() {
    return this._editorState;
  }

  public updateAccessorySelection(update: boolean, reset: boolean): void {
    const action: AcessorySelectionUpdateAction = {
      update: update,
      reset: reset,
    };
    this.updateAccessorySelectionSubject.next(action);
  }

  public editorModeChanged(mode: AccessoryEditorMode): void {
    this._editorMode = mode;
  }

  public editorStateChanged(state: AccessoryEditorState): void {
    this._editorState = state;
  }

  public closeAccessories(): void {
    const action: AccessoryEditorAction = { action: this.ACTION_CLOSE_ACCESSORIES };
    this.actionAccessoriesEditorSubject.next(action);
  }

  public openAccessories(searchType: string): void {
    const action: AccessoryEditorAction = {
      action: this.ACTION_OPEN_ACCESSORIES,
      searchType: searchType,
    };
    this.actionAccessoriesEditorSubject.next(action);
  }

  public updateAccessories(): void {
    const action: AccessoryEditorAction = { action: this.ACTION_UPDATE_ACCESSORIES };
    this.actionAccessoriesEditorSubject.next(action);
  }
}
